import {
  PeriodicAuditState,
  PeriodicAuditActionTypes,
  GET_PERIODIC_AUDIT,
  GET_PERIODIC_AUDIT_LIST_FULFILLED,
  GET_PERIODIC_AUDIT_PENDING,
  GET_PERIODIC_AUDIT_FULFILLED,
  SELECT_PERIODIC_AUDIT,
  SET_PERIODIC_AUDIT_LOADING,
} from './periodicAudit.types';

export const initialState: PeriodicAuditState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function periodicAuditReducer(
  state = initialState,
  action: PeriodicAuditActionTypes,
): PeriodicAuditState {
  switch (action.type) {
    case GET_PERIODIC_AUDIT:
      return {
        ...state,
        selected: [],
      };

    case GET_PERIODIC_AUDIT_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_PERIODIC_AUDIT_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_PERIODIC_AUDIT_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_PERIODIC_AUDIT:
      return {
        ...state,
        selected: action.payload || [],
      };

    case SET_PERIODIC_AUDIT_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
